import { selectFeatureFlag } from 'reducers/selectors';
export const selectEnablePromptMarketplaceReview = (store) => selectFeatureFlag(store, 'prompt_marketplace_review').value;
